import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAgents } from "@/components/Agents/AgentsContext";
import { agentsHref } from "@/lib/atwAgentsHost";

const COLUMNS = [
  { id: "done" as const, title: "Done", description: "Runs Overseer accepted as complete" },
  { id: "stalled" as const, title: "Stalled", description: "Waiting on a system or human" },
  { id: "exception" as const, title: "Exception", description: "Stops, failures, escalations" },
];

export function OverseerPage() {
  const { org } = useAgents();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Overseer</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Included on every plan. Watches agents across your organization and links into
          timeline events.
        </p>
      </div>

      <div className="grid gap-4 lg:grid-cols-3">
        {COLUMNS.map((col) => {
          const rows = org.overseer.filter((r) => r.status === col.id);
          return (
            <Card key={col.id}>
              <CardHeader>
                <CardTitle className="flex items-center justify-between text-base">
                  {col.title}
                  <Badge variant="secondary">{rows.length}</Badge>
                </CardTitle>
                <CardDescription>{col.description}</CardDescription>
              </CardHeader>
              <CardContent className="space-y-3">
                {rows.map((row) => (
                  <Link
                    key={row.id}
                    to={`${agentsHref(`/agents/${row.agentId}`)}#${row.timelineEventId}`}
                    className="block rounded-md border border-gray-200 px-3 py-2 text-sm hover:bg-gray-50 dark:border-white/10 dark:hover:bg-white/5"
                  >
                    <p className="font-medium text-gray-900 dark:text-white">{row.agentName}</p>
                    <p className="mt-0.5 text-gray-600 dark:text-gray-400">{row.summary}</p>
                    <p className="mt-1 text-xs text-gray-500">
                      {new Date(row.updatedAt).toLocaleString()} · open timeline
                    </p>
                  </Link>
                ))}
                {rows.length === 0 ? (
                  <p className="text-sm text-muted-foreground">Nothing in this column yet.</p>
                ) : null}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
